<template>
  <div>
    <va-modal
      v-model="showModal"
      ref="commentModal"
      :no-outside-dismiss="true"
      :cancelText="$t('modal.cancel')"
      :okText="$t('references.inputs.save')"
      :okClass="'btn btn-primary btn-micro'"
      cancelClass="btn-cancelar btn btn-primary btn-micro"
      @ok="saveComment"
      @cancel="cancelComment"
      :ok-disabled="editingComment === null || editingComment === ''"
      size="medium">

      <div slot="header">
        {{editingLead.name | capitalize}}
      </div>
      <div>
        <div class="evollu-form">
          <div class="col-12">
            <label class="form-label">{{$t('leads.details.comment')}}</label>
            <va-input
              id="comment-textarea"
              type="textarea"
              :placeholder="$t('leads.details.comment')"
              v-model.trim="editingComment"
              :maxlength="250"
              :rows="4"
            />
          </div>
          <i class="bar"></i>
        </div>
      </div>
    </va-modal>
  </div>

</template>

<script>
import { AnonLeadsService } from '@/api/LeadsService'

export default {
  props: {
    editingLead: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      showModal: false,
      editingComment: '',
    }
  },
  mounted () {
    this.showModal = true
    if (this.editingLead.comment) this.editingComment = this.editingLead.comment
  },
  methods: {
    saveComment: function () {
      AnonLeadsService.updateComment(this.editingLead.id, { comment: this.editingComment }).then(res => {
        this.showModal = false
        setTimeout(() => {
          this.showToast(this.$t('references.errors.success'), this.$store.state.successToastOptions)
          this.$emit('saved')
        }, 250)
      }).catch(err => {
        console.log(err)
        this.showModal = false
        setTimeout(() => {
          this.showToast(this.$t('references.errors.server'), this.$store.state.errorToastOptions)
          this.$emit('canceled')
        }, 250)
      })
    },
    cancelComment: function () {
      this.showModal = false
      setTimeout(() => {
        this.$emit('canceled')
      }, 250)
    }
  }
}
</script>

<style scoped>

</style>
